import { Easy69_v1 } from "../frfr-easy69-utils";
import { js_utils } from "../frfr-js-utils";
import { _zzyourmap_LAYER_KEY_PREFIX, _zzyourmap_LAYER_TITLE_ALWAYSSHOW, _zzyourmap_lib_layer_titles_default } from "./zz-yourmap-data-keys-and-values-lib";
import { _zzyourmap_img_url_full_from_parts } from "./zz-yourmap-image-utils";
import { _zzyourmap_convert_layer_title_to_layer_key } from "./zz-yourmap-layer-utils";


//
export const _zzyourmap_extract_destination_map_props_1 = (current_destination_entity, route_subdestination_id, lookup_pack) => {
  console.log('_zzyourmap_extract_destination_map_props_1');
  console.log('route_subdestination_id', route_subdestination_id);
  console.log('current_destination_entity', current_destination_entity);
  // const entity = current_destination_entity;
  const map_props_1 = {
    map_img_url: '',
    w: 0,
    h: 0,
  };
  /*
  "destinacija_map_img_filename": "",
  "destinacija_map_img_folder": "",
  "destinacija_map_img_w": 3840,
  "destinacija_map_img_h": 2160,
  */
  //
  let entity = {};
  let bingo = false;
  let bingo_item = null;
  if (Array.isArray(current_destination_entity?._subdestinations)) {
    current_destination_entity._subdestinations.forEach((item, index) => {
      if (bingo === false) {
        // if (route_subdestination_id === null && item.destinacija_tip === "DESTINATION") {
        if (route_subdestination_id === null && item._is_main_subdestionation === true) {
          bingo = true; // prevent another bingo
          bingo_item = item;
          // return bingo_item;
        }
        if (bingo === false) {
          // if (route_subdestination_id > 0 && item.destinacija_tip === "SUBDESTINATION" && route_subdestination_id === item.of_id) {
          if (route_subdestination_id > 0 && !(item._is_main_subdestionation === true) && route_subdestination_id === item.of_id) {
            bingo = true; // prevent another bingo
            bingo_item = item;
            // return bingo_item;
          }
        }
      }
    });
  }
  console.log('bingo', bingo, 'bingo_item', bingo_item);
  if (bingo === true) {
    entity = bingo_item;
  }
  //
  // const img_url_full = _zzyourmap_img_url_full_from_parts(entity?.destinacija_map_img_filename, entity?.destinacija_map_img_folder);
  const img_url_full = entity._map_img_url;
  map_props_1.map_img_url = img_url_full;
  // if (entity?.destinacija_map_img_w > 0) {
  if (entity?._map_img_w > 0) {
    // map_props_1.w = entity.destinacija_map_img_w;
    map_props_1.w = entity._map_img_w;
  }
  // if (entity?.destinacija_map_img_h > 0) {
  if (entity?._map_img_h > 0) {
    map_props_1.h = entity._map_img_h;
  }
  console.log('map_props_1', map_props_1);
  return map_props_1;
};


//
export const _zzyourmap_extract_map_props_1_for_smestaj_position_picker = (smestaj_entity, destination_entities) => {
  console.log('_zzyourmap_extract_map_props_1_for_smestaj_position_picker()');
  console.log('smestaj_entity', smestaj_entity);
  console.log('destination_entities', destination_entities);
  let parent_destinacija_id = smestaj_entity.parent_destinacija_id;
  if (Number.parseInt(parent_destinacija_id) > 0) {
    parent_destinacija_id = Number.parseInt(parent_destinacija_id);
  }
  console.log('parent_destinacija_id', parent_destinacija_id);
  let current_destination_entity = {};
  let route_subdestination_id;
  //
  let bingo = false;
  let bingo_item = null;
  destination_entities.forEach((item) => {
    if (bingo === false && item.vr_tablename === 'ym_table_destination') {
      if (item.destinacija_tip === "DESTINATION") {
        if (item.of_id > 0 && item.of_id === parent_destinacija_id) { // BINGO
          bingo = true; // prevent another bingo
          // current_destination_entity = { ...item };
          bingo_item = { ...item };
          route_subdestination_id = null;
        }
        if (bingo === false) {
          if (Array.isArray(item._subdestinations)) {
            item._subdestinations.forEach((subdestionation_item) => {
              if (subdestionation_item.of_id > 0 && subdestionation_item.of_id === parent_destinacija_id) { // BINGO
                bingo = true; // prevent another bingo
                // current_destination_entity = { ...item };
                bingo_item = { ...item };
                route_subdestination_id = subdestionation_item.of_id;
              }
            });
          }
        }
      }
    }
  });
  //
  if (bingo === true) {
    current_destination_entity = bingo_item;
  }
  console.log('current_destination_entity', current_destination_entity);
  console.log('route_subdestination_id', route_subdestination_id);
  const map_props_1 = _zzyourmap_extract_destination_map_props_1(current_destination_entity, route_subdestination_id);
  //
  // let map_props_markers_arr = [];
  const map_props_2 = {
    ...map_props_1,
    markers_arr: [],
  };
  // const marker_single = _zzyourmap_extract_smestaj_map_marker_item_props(item);
  const marker_single = _zzyourmap_extract_smestaj_map_marker_item_props(smestaj_entity);
  if (marker_single) {
    map_props_2.markers_arr.push(marker_single);
  }
  //
  console.log('map_props_1', map_props_1);
  console.log('map_props_2', map_props_2);
  // return map_props_1;
  return map_props_2;
};


//
export const _zzyourmap_extract_smestaj_map_marker_item_props = (entity) => {
  const item = entity;
  let valid = true;
  const marker_single = {
    marker_img_src: '',
    w: 0,
    h: 0,
    left: 0,
    bottom: 0,
    iconAnchor: null, // iconAnchor null Centered by default if size is specified
    iconAnchor_left: 0, //
    iconAnchor_top: 0, //
    // canvas_w: 0, //
    // canvas_h: 0, //
    // animation: null,
    img_class: "ym-script__marker__icon-img ym-script__marker__icon-default", // TODO
    html_v1_img_container_class: "ym-script__marker__v1-icon-container", // TODO
    html_v3_center_class: "ym-script__marker__v2-center ym-script__marker__bearer ym-script__marker__scalable",
    entity: {},
    layer_key: "layer_default",
    layer_title: null, // TODO novo
    custom_class: "ym-script__marker__layer_default",
    marker_is_link: false,
    marker_link_href: null,
    marker_link_target: "_blank",
    marker_is_clickable: true,
    is_hideable: true, // marker can be hidden by default
  };
  /*
  "smestaj_marker_enabled": true,
  "smestaj_marker_animacija": "",
  "smestaj_marker_img_filename": "",
  "smestaj_marker_img_folder": "",
  "smestaj_marker_img_w": 40,
  "smestaj_marker_img_h": 40,
  "smestaj_marker_img_left": 0,
  "smestaj_marker_img_bottom": 0,
  */
  if (item?.smestaj_marker_enabled === true) {
    if (item?.smestaj_marker_img_w > 0 && item?.smestaj_marker_img_h > 0) {
      const img_url_full = _zzyourmap_img_url_full_from_parts(item?.smestaj_marker_img_filename, item?.smestaj_marker_img_folder);
      marker_single.marker_img_src = img_url_full;
      marker_single.w = item.smestaj_marker_img_w;
      marker_single.h = item.smestaj_marker_img_h;
      marker_single.canvas_w = item.smestaj_marker_img_w;
      marker_single.canvas_h = item.smestaj_marker_img_h;
      if (item?.of_id > 0) {
        marker_single.key = item.of_id;
      }
      if (item?.smestaj_marker_is_link === true) {
        marker_single.marker_is_link = true;
        if (typeof item?.smestaj_marker_link_href === 'string') {
          marker_single.marker_link_href = item.smestaj_marker_link_href;
        }
        if (item?.smestaj_marker_link_target === '_self') {
          marker_single.marker_link_target = '_self';
        }
      }
      //
      // marker_single.layer_key = "default_layer",
      /*
      if (item.vr_tablename === 'ym_table_smestaj') {
        marker_single.layer_key = "layer_smestaji";
        marker_single.custom_class = "ym-script__marker__layer_smestaji";
      } else if (item.vr_tablename === 'ym_table_aktivnost') {
        marker_single.layer_key = "layer_aktivnosti";
        marker_single.custom_class = "ym-script__marker__layer_aktivnosti";
      } else if (item.vr_tablename === 'ym_table_restoran') {
        marker_single.layer_key = "layer_ugostitelji";
        marker_single.custom_class = "ym-script__marker__layer_ugostitelji";
      } else if (item.vr_tablename === 'ym_table_prodavnica') {
        marker_single.layer_key = "layer_prodavnice";
        marker_single.custom_class = "ym-script__marker__layer_prodavnice";
      } else if (item.vr_tablename === 'ym_table_servis') {
        marker_single.layer_key = "layer_servisi";
        marker_single.custom_class = "ym-script__marker__layer_servisi";
      } else if (item.vr_tablename === "ym_table_ostalo_v1") {
        if (item.smestaj_layer && js_utils.is_string_not_empty(item.smestaj_layer) && _zzyourmap_lib_legend_keys.includes(item.smestaj_layer)) {
          marker_single.layer_key = "layer_" + item.smestaj_layer;
          marker_single.custom_class = "ym-script__marker__layer_" + item.smestaj_layer; //
        }
      }
      */
      // TODO NOVO
      if (typeof item._marker_layer_title === 'string') {
        marker_single.layer_title = item._marker_layer_title;
        marker_single.layer_key = _zzyourmap_convert_layer_title_to_layer_key(marker_single.layer_title);
        marker_single.custom_class = "ym-script__marker__" + marker_single.layer_key; //
        if (item._marker_layer_title === _zzyourmap_LAYER_TITLE_ALWAYSSHOW) {
          marker_single.is_hideable = false;
        }
      }
      if (
        item?.vr_tablename === 'ym_table_ignored'
        && item?._marker_layer_title === _zzyourmap_LAYER_TITLE_ALWAYSSHOW
        && marker_single.marker_is_link === true
      ) {
        marker_single.marker_is_clickable = false;
      }
      //
      if (item?.smestaj_marker_img_left > 0) {
        marker_single.left = item.smestaj_marker_img_left;
      }
      if (item?.smestaj_marker_img_bottom > 0) {
        marker_single.bottom = item.smestaj_marker_img_bottom;
      }
      if (item?.smestaj_marker_zoom_disabled === true) {
        marker_single.html_v3_center_class = "ym-script__marker__v2-center ym-script__marker__bearer ym-script__marker__zoom-disabled";
      } else if (item?.smestaj_marker_zoom_follow_enabled === true) {
        marker_single.html_v3_center_class = "ym-script__marker__v2-center ym-script__marker__bearer ym-script__marker__zoom-follow";
      } else {
        marker_single.html_v3_center_class = "ym-script__marker__v2-center ym-script__marker__bearer ym-script__marker__scalable";
      }
      if (item?.smestaj_marker_animacija === 'bounce') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-bounce"; //
      } else if (item?.smestaj_marker_animacija === 'bounce_10') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-bounce-10"; //
      } else if (item?.smestaj_marker_animacija === 'pulse') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-pulse"; //
      } else if (item?.smestaj_marker_animacija === 'float') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-float"; //
      } else if (item?.smestaj_marker_animacija === 'wiggle') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-wiggle"; //
      } else if (item?.smestaj_marker_animacija === 'shake_1') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-shake-1"; // TODO
      } else if (item?.smestaj_marker_animacija === 'shake_2') {
        marker_single.img_class = "ym-script__marker__icon-img ym-script__marker__icon-shake-2"; // TODO
      }
      if (js_utils.is_number_zero_or_greater(item.smestaj_marker_img_anchor_left) && js_utils.is_number_zero_or_greater(item.smestaj_marker_img_anchor_top)) {
        marker_single.iconAnchor = [item.smestaj_marker_img_anchor_left, item.smestaj_marker_img_anchor_top];
        marker_single.iconAnchor_left = item.smestaj_marker_img_anchor_left;
        marker_single.iconAnchor_top = item.smestaj_marker_img_anchor_top;
        //
        /*
        if (item.smestaj_marker_img_anchor_left > (item.smestaj_marker_img_w / 2)) {
          marker_single.canvas_w = (2 * item.smestaj_marker_img_anchor_left);
        } else {
          marker_single.canvas_w = (2 * (item.smestaj_marker_img_w - item.smestaj_marker_img_anchor_left));
        }
        if (item.smestaj_marker_img_anchor_top > (item.smestaj_marker_img_h / 2)) {
          marker_single.canvas_h = (2 * item.smestaj_marker_img_anchor_top);
        } else {
          marker_single.canvas_h = (2 * (item.smestaj_marker_img_h - item.smestaj_marker_img_anchor_top));
        }
        */
      }
      marker_single.tooltip_text = item.smestaj_naslov;
      marker_single.disable_tooltip = true;
      marker_single.entity = { ...item };
      // marker_single.marker_popup_main_img_src = '';
      // marker_single.marker_popup_main_img_src = _zzyourmap_extract_smestaj_main_img_url(item);
    } else {
      valid = false;
    }
  } else {
    valid = false;
  }
  if (valid === true) {
    return marker_single;
  } else {
    return false;
  }
};
